import React from 'react'

const PrizeCourses = () => {
  return (
    <div>
      
    </div>
  )
}

export default PrizeCourses
